import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Auth0Provider } from '@auth0/auth0-react'

import './assets/scss/core.scss'
import './index.css'

const authZeroDomain = process.env.REACT_APP_AUTH_ZERO_DOMAIN
const authZeroClientId = process.env.REACT_APP_AUTH_ZERO_CLIENT_ID
const authZeroAudience = process.env.REACT_APP_AUTH_ZERO_AUDIENCE

// const DEFAULT_REDIRECT_CALLBACK = (data) => {
//     const { targetUrl } = data
//     const redirectToUri = targetUrl || window.location.pathname + window.location.search
//     return window.history.replaceState({}, document.title, redirectToUri)
// }

ReactDOM.render(
    <Auth0Provider
        domain={authZeroDomain}
        clientId={authZeroClientId}
        redirectUri={window.location.origin}
        // onRedirectCallback={() => {
        //     debugger
        //     DEFAULT_REDIRECT_CALLBACK()
        // }}
        audience={authZeroAudience}
        // authorizationParams={{
        //     audience: authZeroAudience,
        //     redirect_uri: window.location.origin,
        // }}
    >
        <App />
    </Auth0Provider>,
    document.getElementById('root')
)

// registerServiceWorker()
